import { useQuery } from '@tanstack/react-query';
import { getTask } from 'api/task.service';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { useTaskStore } from 'store/task.store';

export const useTaskGetQuery = (id: string) => {
  const draftTask = useTaskStore((state) => state.draft);
  const toast = useToast();

  const { data, isInitialLoading, isError } = useQuery(
    ['tasks', id],
    () => getTask(id),
    {
      retry: false,
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
      enabled: !!id,
      refetchInterval: 1000 * 60,
      refetchIntervalInBackground: draftTask?.status !== 'NOT_SAVED',
    },
  );

  return { isLoading: isInitialLoading, isError, data };
};
